import { memo } from "react";

import { Heading } from "@components/Heading";
import { TruncatedText } from "@components/TruncatedText";
import { ReviewStars } from "@react/sections/ProductReviews/ReviewStars";
import { type ReviewItemBlock } from "@root/tablescape/state";
import { type TTailwindString, tw } from "classnames";

type Props = {
  className?: TTailwindString | undefined;
} & ReviewItemBlock;

const styles = {
  reviewStars: tw("text-special"),
  heading: tw("mb-2"),
};

const ReviewBlockBase = ({
  className,
  description,
  starRating,
  title,
}: Props) => {
  return (
    <div className={className}>
      <ReviewStars
        className={styles.reviewStars}
        rating={starRating}
        size="sm"
      />
      <Heading as="h3" className={styles.heading} size="xs">
        {title}
      </Heading>
      <TruncatedText as="caption">{description}</TruncatedText>
    </div>
  );
};

export const ReviewBlock = memo(ReviewBlockBase);
